/**
 * Token Storage Helper
 * Sessions persist in localStorage — you stay signed in until you sign out.
 */

const REMEMBER_KEY = 'remember_me';
const TOKEN_KEY = 'session_token';

export function setRememberMe(value) {
  if (value) {
    localStorage.setItem(REMEMBER_KEY, 'true');
  } else {
    localStorage.removeItem(REMEMBER_KEY);
  }
}

export function isRemembered() {
  return localStorage.getItem(REMEMBER_KEY) === 'true';
}

export function setToken(token) {
  localStorage.setItem(TOKEN_KEY, token);
  sessionStorage.removeItem(TOKEN_KEY);
}

export function getToken() {
  // migrate any legacy sessionStorage token into persistent storage
  const legacy = sessionStorage.getItem(TOKEN_KEY);
  if (legacy && !localStorage.getItem(TOKEN_KEY)) {
    localStorage.setItem(TOKEN_KEY, legacy);
    sessionStorage.removeItem(TOKEN_KEY);
  }
  return localStorage.getItem(TOKEN_KEY) || sessionStorage.getItem(TOKEN_KEY);
}

export function clearToken() {
  localStorage.removeItem(TOKEN_KEY);
  sessionStorage.removeItem(TOKEN_KEY);
}

export function clearAllAuth() {
  clearToken();
  localStorage.removeItem(REMEMBER_KEY);
  localStorage.removeItem('auth-storage');
  sessionStorage.removeItem('auth-storage');
}
